<!-- Laufschrift NUR bei Mouseover (kein Autoplay, Stand 23.09.2026): alle
     `.marquee`-Texte stehen abgeschnitten da und laufen erst, wenn der Zeiger
     auf der Kachel ist — Überschrift eingeschlossen. -->
<div class="card {{ size }}" (click)="openTutorPage()" appMarqueeOnHover=".marquee">
  <!-- Kopf: links Template + Agent-Name, rechts der Orb des Templates.
       Der Orb ersetzt das Kunden-Logo an dieser Stelle — das Logo sitzt
       jetzt unten in der Chat-Styling-Zeile. -->
  <!-- NICHT `class="header"` nennen: `nb-layout-column .header h2` in
       styles.scss ist die portalweite Seitenkopf-Regel und setzt
       `font-size: 2.2rem !important; font-weight: 400 !important` plus die
       Einblend-Animation. Sie hat die Kachel-Überschrift überschrieben
       (Marcel, 23.09.2026). -->
  <header class="card-head">
    <div class="heading">
      <p class="eyebrow marquee">
        {{
          tutorTemplate
            ? ("enums.assistantTemplate." + tutorTemplate.name | translate)
            : ""
        }}
      </p>
      <!-- Der Verlauf sitzt auf dem inneren <span>, nicht auf der <h2>.
           Chromium zeichnet eine per `background-clip: text` maskierte
           Fläche beim Scrollen der EIGENEN Box nicht neu — die Laufschrift
           änderte `scrollLeft`, das Bild blieb stehen. Scrollt dagegen der
           Container und der Verlauf liegt auf dem mitwandernden Inline-Text,
           folgt die Darstellung. `display: inline` ist Pflicht: ein
           inline-block wäre atomar und die Ellipse der <h2> griffe nicht. -->
      <h2 class="title marquee"><span class="title__ink">{{ tutor.name }}</span></h2>
    </div>
    <app-orbi-lab
      class="orb"
      [type]="orbType"
      [size]="orbSize"
      [script]="personalityScript"
      [gaze]="orbiGaze"
      [gazeJitter]="orbiGazeJitter"
    ></app-orbi-lab>
  </header>

  <!-- Reihenfolge der Zeilen ist von Marcel gesetzt (23.09.2026):
       Anzeigename, Erstellt von, Dozent, Wissensbasis, Live in Kursen,
       Aktive Benutzer, Chat-Styling. -->
  <dl class="items">
    <div class="item visible-name">
      <dt class="term">
        <span class="relief-icon icon--window" aria-hidden="true"
          ><span class="relief-glyph"></span
        ></span>
        <span class="label marquee">{{ "input.displayName.label" | translate }}</span>
      </dt>
      <dd class="value marquee">{{ tutor.visual_name || tutor.name }}</dd>
    </div>

    <!-- Creator attribution — historical fact from the backend list JOIN,
         never reassigned. Falls back to "Unbekannt" when the creator is
         unknown (legacy agent / demo copy). -->
    <div class="item creator">
      <dt class="term">
        <span class="relief-icon icon--person" aria-hidden="true"
          ><span class="relief-glyph"></span
        ></span>
        <span class="label marquee">{{ "pages.tutors.createdByLabel" | translate }}</span>
      </dt>
      <dd class="value marquee">
        {{ tutor.created_by_name || ("pages.tutors.createdByUnknown" | translate) }}
      </dd>
    </div>

    <!-- Lecturer attachment badge — only shows when an alpha_dozent
         bot is linked. Populated by the backend list endpoint to avoid
         a per-card fetch. -->
    <div *ngIf="tutor.attached_dozent_name" class="item dozent-link">
      <dt class="term">
        <span class="relief-icon icon--book" aria-hidden="true"
          ><span class="relief-glyph"></span
        ></span>
        <span class="label marquee">{{ "pages.tutors.dozentBadgeLabel" | translate }}</span>
      </dt>
      <dd class="value marquee">{{ tutor.attached_dozent_name }}</dd>
    </div>

    <div class="item knowledge">
      <dt class="term">
        <span class="relief-icon icon--brain" aria-hidden="true"
          ><span class="relief-glyph"></span
        ></span>
        <span class="label marquee">{{ "pages.tutors.tabKnowledgeBase" | translate }}</span>
      </dt>
      <dd class="value number">{{ tutor.data_source_ids?.length }}</dd>
    </div>

    <!-- In wie vielen LMS-Kursen der Agent für Lernende sichtbar ist.
         Gezählt werden Kurse, nicht Platzierungen — drei Blöcke im selben
         Kurs sind ein Kurs. Der Wert kommt fertig aus dem Listen-Endpunkt
         (`live_course_count`), damit keine Kachel selbst nachlädt. -->
    <div class="item live-courses">
      <dt class="term">
        <span class="relief-icon icon--courses" aria-hidden="true"
          ><span class="relief-glyph"></span
        ></span>
        <span class="label marquee">{{ "pages.tutors.liveInCourses" | translate }}</span>
      </dt>
      <dd class="value number">{{ liveCourseCount }}</dd>
    </div>

    <div class="item active-users">
      <dt class="term">
        <span class="relief-icon icon--users" aria-hidden="true"
          ><span class="relief-glyph"></span
        ></span>
        <span class="label marquee">{{ "pages.tutors.activeUsers" | translate }}</span>
      </dt>
      <dd class="value number">{{ activeUsers }}</dd>
    </div>

    <div class="item chat-styling">
      <dt class="term">
        <span class="relief-icon icon--brush" aria-hidden="true"
          ><span class="relief-glyph"></span
        ></span>
        <span class="label marquee">{{ "input.chatStyleSelect.label" | translate }}</span>
      </dt>
      <dd class="value">
        <!-- Farbtupfer plus — falls hinterlegt — das Logo des Kunden. Das
             Logo stand früher oben rechts; dort sitzt jetzt der Orb.
             `background` statt `background-color`: Flächenfarben dürfen ein
             Verlauf sein (Chat-Styling) und erscheinen dann als Verlauf. -->
        <div class="branding">
          <span class="colors">
            <span [style.background]="backgroundColor"></span>
            <span [style.background]="botTextColor"></span>
            <span [style.background]="userTextColor"></span>
            <span [style.background]="secondaryColor"></span>
            <span [style.background]="primaryColor"></span>
          </span>
          @if (effectiveLogoUrl) {
          <span class="brand-separator" aria-hidden="true"></span>
          <span class="brandmark">
            <img [src]="effectiveLogoUrl" alt="Logo" (error)="onLogoLoadError()" />
          </span>
          }
        </div>
      </dd>
    </div>
  </dl>

  <!-- Vier Aktionen, nur Icons — jede trägt ihren Namen als Tooltip und als
       aria-label, sonst ist sie nicht benennbar. Der Tooltip steht oben:
       die Leiste sitzt an der Unterkante der Kachel. -->
  <div class="overlay">
    <div
      class="button"
      alAnchor="agents.card-play"
      (click)="onStartChat($event)"
      [nbTooltip]="
        (isChatActive
          ? 'pages.tutors.cardActions.chatStop'
          : 'pages.tutors.cardActions.chatStart'
        ) | translate
      "
      nbTooltipPlacement="top"
      [attr.aria-label]="
        (isChatActive
          ? 'pages.tutors.cardActions.chatStop'
          : 'pages.tutors.cardActions.chatStart'
        ) | translate
      "
    >
      <nb-icon
        status="primary"
        [icon]="isChatActive ? 'stop-circle-outline' : 'play-circle-outline'"
      ></nb-icon>
    </div>
    <!-- Kein eigener Handler: der Klick fällt auf die Kachel durch, die den
         Agenten öffnet. -->
    <div
      class="button"
      [nbTooltip]="'pages.tutors.cardActions.edit' | translate"
      nbTooltipPlacement="top"
      [attr.aria-label]="'pages.tutors.cardActions.edit' | translate"
    >
      <nb-icon status="primary" icon="edit-outline"></nb-icon>
    </div>
    <div
      class="button"
      (click)="onDuplicateTutor($event)"
      [nbTooltip]="'pages.tutors.cardActions.duplicate' | translate"
      nbTooltipPlacement="top"
      [attr.aria-label]="'pages.tutors.cardActions.duplicate' | translate"
    >
      <nb-icon status="primary" icon="copy-outline"></nb-icon>
    </div>
    <div
      class="button"
      (click)="onDeleteTutor($event)"
      [nbTooltip]="'pages.tutors.cardActions.delete' | translate"
      nbTooltipPlacement="top"
      [attr.aria-label]="'pages.tutors.cardActions.delete' | translate"
    >
      <nb-icon status="danger" icon="trash-outline"></nb-icon>
    </div>
  </div>
</div>
